// extracted by mini-css-extract-plugin
export default {"slashCommandContainer":"SlashCommandsProvider-module__slashCommandContainer--ZPT3l"};